import { resolutionsAdapterSelectors } from '../redux/slices/resolutions';
import { createSelector } from 'reselect';

const getCurrentWorkspaceResolutionsFromStore = (state) =>
  state.currentWorkspace.resolutions;

export const currentWorkspaceResolutions = createSelector(
  getCurrentWorkspaceResolutionsFromStore,
  (state) => (id) => resolutionsAdapterSelectors.selectById(state, id),
  (resolutionIds, getResolutionById) =>
    resolutionIds.map((resolutionId) => {
      const resolution = getResolutionById(resolutionId);
      if (resolution.custom) {
        return {
          ...resolution,
          ...resolution.custom,
          default: resolution,
          isDefault: false,
        };
      }
      return resolution;
    })
);
